export default "__VITE_PUBLIC_ASSET__be47cf0e__"